import { Component, OnInit,ViewChild,ElementRef,Renderer2 } from '@angular/core';
import { apiUrlComponent } from '../common/api.url.component';
import { ApiService } from '../common/API/api.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import * as $ from 'jquery';
import {MatPaginator, MatTableDataSource} from '@angular/material';
declare var config;
import {BackRestrict} from '../common/backRestrict'

@Component({
  selector: 'app-store',
  templateUrl: './store.component.html',
  styleUrls: ['./store.component.css']
})
export class StoreComponent implements OnInit {
  @ViewChild('ddlenterprise') ddlenterprise: ElementRef;
  @ViewChild('ddlenterprisePartner') ddlenterprisePartner: ElementRef;

  public dataSource :  MatTableDataSource<storeInfo>;
  public Storelist: storeInfo[]= [];;
  public Enterpriselist:any;
  public EnterprisePartnerlist: any;
  public TimeZonelist: any;
  public Countrylist: any;
  public Storetypelist: any;
  public modfyEnterprisePartnerList:any;
  public submitted: boolean = false;
  public modfyTimeZoneList:any;
  public modfyCountryList:any;
  public modfyStoreTypeList:any;
  form: FormGroup;
  responseResult='';
  public Cond_Store : any;
  dropdownlist: boolean;

  private readonly notifier: NotifierService;
  constructor(private _apiService: ApiService,private backrestrict:BackRestrict,private formbuilder: FormBuilder, private apiUrl: apiUrlComponent,notifierService: NotifierService, private renderer: Renderer2) { 
     this.form = formbuilder.group({
      Enterprise :['',Validators.required],
      EnterprisePartner :['',Validators.required],
      Store:['',Validators.required],
    });
    this.notifier = notifierService;
  }
  @ViewChild(MatPaginator) paginator: MatPaginator;
  public pageSizeOptions=[5,10,15,20];
  public pageSize=10;
  public length=10;
  public displayedColumns  = ['StoreID', 'Store','BaseEnterprise','Enterprise', 'Action', 'IsActive'];

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  
  ngOnInit() {
    this.backrestrict.clearBrowserBackHistory();
    this.GetStore();
  }
  GetStore() {
    debugger;
    this._apiService.get(config.urlpath + 'api/getstore').subscribe(result => {
      debugger;
      if (result.Success === true) {
        debugger;
        this.Storelist = result.Data[0];
        this.dataSource = new MatTableDataSource(this.Storelist);
        this.dataSource.paginator = this.paginator;
        this.Enterpriselist=result.Data[1].filter(x=>x.Enterprise!=='Corporate');;
        this.EnterprisePartnerlist=result.Data[2];
        // this.TimeZonelist=result.Data[3];
        // this.Countrylist=result.Data[4];
        // this.Storetypelist=result.Data[5];
      } 
      else {
    }
  },
      error => {
        console.log(error);
      }
    );
  }
  onChangeEnterprise(event){
    debugger;
    var EnterpriseID=event;
    //this.ddlenterprisePartner.nativeElement.value='0'; 
    this.modfyEnterprisePartnerList = this.EnterprisePartnerlist.filter((item) => item.EnterpriseID == EnterpriseID);    
    this.form.controls['EnterprisePartner'].setValue('0');
  }
  AddStore(){
    debugger;
    if(this.form.valid)
    {
      var Addbody={
        EnterprisePartnerID:this.form.value.EnterprisePartner,
        Store:this.form.value.Store,
        // TimeZone:this.form.value.TimeZone,
        // Country: this.form.value.Country,
        // Storetype:this.form.value.Storetype,
        // StoreContactPerson:this.form.value.StoreContactPerson,
        // StoreEmailAddress:this.form.value.StoreEmailAddress,
        // StoreContactNumber:this.form.value.StoreContactNumber,
        // Address1:this.form.value.Address1,
        // Address2:this.form.value.Address2,
        // Address3:this.form.value.Address3,
        // City:this.form.value.City,
        // PostCode:this.form.value.PostCode
      }
      this._apiService.post(config.urlpath + 'api/addstore',Addbody).subscribe(result => {
        if (result.Success === true) {
          debugger;
          $('#ModalClsbtn').click();
          this.notifier.notify( 'success', 'Store Added Successfully' );
          // setTimeout(
          //   function(){ 
          //     location.reload(true);
          //   }, 2000);
          this.GetStore();
        } else {
          //$('#ModalClsbtn').click();
          this.notifier.notify( 'error', 'An Error Occured' );
          this.GetStore();
        }
      },
        error => {
          console.log(error);
          this.GetStore();
        }
      );
    }
    else{
      this.notifier.notify( 'error', 'All fields required' );
    }
 
  }
  editStore(item: any) {
    debugger;
    this.Cond_Store = item;
    this.form.controls.Enterprise.patchValue(item.EnterpriseID);
    this.modfyEnterprisePartnerList = this.EnterprisePartnerlist.filter((items) => items.EnterpriseID == item.EnterpriseID); 
    this.form.controls.EnterprisePartner.patchValue(item.EnterprisePartnerID);
    this.form.controls.Store.patchValue(item.Store);
 }

  UpdateStore(item){
    debugger
    var UpdateBody ={
      StoreID :item,
      EnterprisePartnerID:this.form.value.EnterprisePartner,
      Store:this.form.value.Store,
      // TimeZone:this.form.value.TimeZone,
      // Country:this.form.value.Country,
      // Storetype:this.form.value.Storetype,
      // StoreContactPerson:this.form.value.StoreContactPerson,
      // StoreEmailAddress:this.form.value.StoreEmailAddress,
      // StoreContactNumber:this.form.value.StoreContactNumber,
      // Address1:this.form.value.Address1,
      // Address2:this.form.value.Address2,
      // Address3:this.form.value.Address3,
      // City:this.form.value.City,
      // PostCode:this.form.value.PostCode,
       };
       this._apiService.post(config.urlpath + 'api/addstore',UpdateBody).subscribe(result => {
        if (result.Success === true) {
          $('#ModalClsbtn').click();
          this.notifier.notify( 'success', 'Store Updated Successfully' );
          // setTimeout(
          //   function(){ 
          //     location.reload(true);
          //   }, 2000);
          this.GetStore();
        } else {
          //$('#ModalClsbtn').click();
          this.notifier.notify( 'error', 'An Error Occured' );
          this.GetStore();
        }
      },
        error => {
          console.log(error);
          this.GetStore();
        }
      );

  }

  onChange(event,item:any){
    debugger;
    var IsActiveBody ={
       StoreID :item,
       IsActive:event
        };
    this._apiService.post(config.urlpath + 'api/addstore' , IsActiveBody).subscribe(result => {
      debugger;
      if(event)
      {
        this.notifier.notify('success', 'Store Activated Successfully');
      }
      else {
        this.notifier.notify('warning', 'Store Deactivated Successfully');
      }
    })
  }

  emptyform(){
    debugger;
    this.Cond_Store = undefined;
    this.form.reset();
    this.form.controls['Enterprise'].setValue('0');
    this.form.controls['EnterprisePartner'].setValue('0');
    

  }
  keyPressNumbers(event: any) {
    debugger;
    const pattern = /^[0-9]*$/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  keyPressName(event: any) {
    debugger;
    const pattern =  /^[a-zA-Z ]*$/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  // onBlurMethod(val: any) {
  //   if (val !== '') {
  //     const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  //     if (!pattern.test(val)) {
  //     }
  //     else {
  //       this.invalidEmail = false;
  //     }
  //   }
  //   else {

  //     this.invalidEmail = false;
  //   }
  // }
  // keyPressEmail() {
  //   this.invalidEmail = false;
  // }
 
}
export interface storeInfo {
  StoreID: number;
  Store: string;
  EnterprisePartner: string ;
  Enterprise: string;
}
